import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';
import { Tooltip } from '@fluentui/react-components';
import HintIcon from '../HintIcon';

const Div: any = styled.label<{
  display: string;
  width: string;
  verticalAlign: CSSProperties['verticalAlign'];
  view: boolean;
  bold: boolean;
}>`
  display: ${(props) => (props.display ? props.display : 'inline-block')};
  width: ${(props) => {
    if (props.width) {
      return props.width;
    }
    return props.display && props.display === 'block' ? 'auto' : '100%';
  }};
  margin: 0;
  vertical-align: ${(props: any) => props.verticalAlign};
  font-size: ${(props: any) => (props.view ? '12px' : '14px')};
  font-weight: ${(props: any) => (props.bold ? '600' : '400')};
  color: ${p4Tokens.fieldLabel};
`;

const Label = ({
  bold,
  children,
  display,
  htmlFor,
  onMouseOver,
  onMouseOut,
  view,
  verticalAlign,
  onClick,
  style,
  hint,
}: {
  bold?: boolean;
  children: any;
  display?: boolean;
  htmlFor?: string;
  onMouseOver?: Function;
  onMouseOut?: Function;
  view?: boolean;
  verticalAlign?: string;
  onClick?: Function;
  style?: CSSProperties;
  hint?: ReactNode;
}) => {
  const label = (
    <Div
      verticalAlign={verticalAlign}
      bold={bold}
      display={display}
      htmlFor={htmlFor}
      view={view}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onClick={onClick}
      style={style}
      width={hint ? 'auto' : undefined}
    >
      {children}
      <HintIcon hint={hint} />
    </Div>
  );
  if (hint) {
    return (
      <Tooltip relationship={'label'} content={hint} withArrow={true}>
        {label}
      </Tooltip>
    );
  }

  return label;
};
Label.defaultProps = {
  htmlFor: '',
  bold: false,
  onMouseOut: () => {},
  onMouseOver: () => {},
  display: 'inline-block',
  verticalAlign: 'top',
};

export default Label;
